var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Link } from "react-router-dom";
import { Button, Checkbox, Dimmer, Divider, Form, List, Loader, Message, Modal, TextArea } from "semantic-ui-react";
import CreateOrderForUser from "./admin/CreateOrderForUser";
import { AppPaths, FEATURE_CREATE_ORDER_FOR_USER, ShopLink, UiConfigContext } from "./AppConfig";
import BulkOrderModal from "./BulkOrderModal";
import CartItemView from "./CartItemView";
import { ORIGIN } from "./Config";
import { chromogenKitToConsumerFormState } from "./kit/automated-pro/ChromogenKitToConsumerFormState";
import { defaultChromogenKitFormState } from "./kit/automated-pro/NewChromogenKitPage";
import { defaultMultiPlexFormState } from "./kit/automated-pro/NewMultiPlexProKitPage";
import { isConsumerCatalog, RelevantCatalogType } from "./kit/automated-pro/RnaCatalog";
import { deserializeAdminCatalog, deserializeUserCatalog } from "./kit/automated-pro/RnaCatalog";
import { automatedProKitToProFormState } from "./kit/automated-pro/RnaCishKitToProFormState";
import { MetaCatalog, MetaCatalogLoader } from "./kit/Catalog";
import { defaultManualGoldIfFormState } from "./kit/manual-gold-if/EditKitForm";
import { encoderKitToFormState } from "./kit/manual-gold-if/ManualGoldIfKitToFormState";
import { defaultFormState as defaultManualProConsumerFormState } from "./kit/manual-pro/ManualProConsumerKitForm";
import { manualProKitToConsumerFormState } from "./kit/manual-pro/ManualProKitToConsumerFormState";
import { defaultFormState, discountMessage, formatMonetaryDecimal, } from "./kit/rna-fish/EditKitForm";
import { AutomatedProKit, ManualGoldIfKit, ManualProKit, RnaFishKit, SecondaryIfKit } from "./kit/rna-fish/KitModel";
import { LoadWrapper } from "./kit/rna-fish/LoadWrapper";
import { kitPriceToGoogleAnalyticsItems } from "./kit/rna-fish/NewRnaFishKitPage";
import { rnaFishKitToFormState } from "./kit/rna-fish/RnaFishKitToFormState";
import { defaultSecondaryIfFormState } from "./kit/secondary-if/EditKitForm";
import { deserializeCatalog as deserializeSecondaryIfCatalog } from "./kit/secondary-if/SecondaryIfCatalog";
import { secondaryIfKitToFormState } from "./kit/secondary-if/SecondaryIfKitToFormState";
import StarterKitCartCard, { uniqueStarterKitGroups } from "./kit/StarterKitCartCard";
import KitDeserializer from "./KitDeserializer";
import QuoteDisplay from "./QuoteDisplay";
import { CatalogMode, getWithAuthn, postJsonWithAuthn, postWithAuthn } from "./RequestHelpers";
import { nicknameHelp, nicknamePlaceholder } from "./UserOrderPage";
var CartPage = /** @class */ (function (_super) {
    __extends(CartPage, _super);
    function CartPage(props) {
        var _this = _super.call(this, props) || this;
        _this.showCartItems = function (item, idx, c) {
            if (item instanceof ValidCartItem) {
                var kit = item.pricedKit.kit;
                return React.createElement(CartItemView
                // TODO ugly
                // Only one of the states is used for any given kit, so the default state for the other is harmless
                , { 
                    // TODO ugly
                    // Only one of the states is used for any given kit, so the default state for the other is harmless
                    catalog: c, initialRnaFishEditFormState: kit instanceof RnaFishKit ?
                        rnaFishKitToFormState(c.rnaCatalog, kit, false) :
                        defaultFormState(c.rnaCatalog, false), initialSecondaryIfEditFormState: kit instanceof SecondaryIfKit ?
                        secondaryIfKitToFormState(c.secondaryIfCatalog, kit, false) :
                        defaultSecondaryIfFormState(c.secondaryIfCatalog, false), initialManualGoldIfEditFormState: kit instanceof ManualGoldIfKit ?
                        encoderKitToFormState(c.secondaryIfCatalog, kit, false) :
                        defaultManualGoldIfFormState(c.secondaryIfCatalog), initialManualProFormState: kit instanceof ManualProKit ?
                        manualProKitToConsumerFormState(c.rnaCatalog, kit) :
                        defaultManualProConsumerFormState(c.rnaCatalog), initialRnaCishFormState: _this.automatedProKitCheck(kit) ?
                        automatedProKitToProFormState(c.rnaCatalog, kit) :
                        defaultMultiPlexFormState(c.rnaCatalog), initialChromogenKitFormState: _this.proChromogenOnlyKitCheck(kit) ?
                        chromogenKitToConsumerFormState(c.rnaCatalog, kit) :
                        defaultChromogenKitFormState(), item: item, key: idx, offset: idx, onCartChange: _this.handleJsonCart, setParentLoadingState: _this.handleItemLoadingState });
            }
            else {
                var kit = item.invalidKit.kit;
                return React.createElement(CartItemView
                // TODO ugly
                // Only one of the states is used for any given kit, so the default state for the other is harmless
                , { 
                    // TODO ugly
                    // Only one of the states is used for any given kit, so the default state for the other is harmless
                    catalog: c, initialRnaFishEditFormState: kit instanceof RnaFishKit ?
                        rnaFishKitToFormState(c.rnaCatalog, kit, false) :
                        defaultFormState(c.rnaCatalog, false), initialSecondaryIfEditFormState: kit instanceof SecondaryIfKit ?
                        secondaryIfKitToFormState(c.secondaryIfCatalog, kit, false) :
                        defaultSecondaryIfFormState(c.secondaryIfCatalog, false), initialManualGoldIfEditFormState: kit instanceof ManualGoldIfKit ?
                        encoderKitToFormState(c.secondaryIfCatalog, kit, false) :
                        defaultManualGoldIfFormState(c.secondaryIfCatalog), initialManualProFormState: kit instanceof ManualProKit ?
                        manualProKitToConsumerFormState(c.rnaCatalog, kit) :
                        defaultManualProConsumerFormState(c.rnaCatalog), initialRnaCishFormState: _this.automatedProKitCheck(kit) ?
                        automatedProKitToProFormState(c.rnaCatalog, kit) :
                        defaultMultiPlexFormState(c.rnaCatalog), initialChromogenKitFormState: _this.proChromogenOnlyKitCheck(kit) ?
                        chromogenKitToConsumerFormState(c.rnaCatalog, kit) :
                        defaultChromogenKitFormState(), item: item, key: idx, offset: idx, onCartChange: _this.handleJsonCart, setParentLoadingState: _this.handleItemLoadingState });
            }
        };
        _this.showIncompatibilityMessage = function (cart) {
            var containsLegacy = cart.contents.find(function (item) {
                return (item.kit instanceof RnaFishKit || item.kit instanceof SecondaryIfKit) && item.kit.legacy;
            });
            var containsGold = cart.contents.find(function (item) {
                return (item.kit instanceof RnaFishKit || item.kit instanceof SecondaryIfKit) && !item.kit.legacy;
            });
            return React.createElement(React.Fragment, null, containsLegacy
                && containsGold
                && ORIGIN === "mi"
                && React.createElement(Message, { color: 'yellow', content: "Please note that HCR™ (v3.0) products and HCR™ Gold products are not compatible for use within the same experiment." }));
        };
        _this.renderCartContents = function () {
            return React.createElement("div", { id: "non-header-portion" },
                React.createElement("div", { id: 'cart-display' },
                    React.createElement("h1", { className: 'branded' }, "Shopping Cart"),
                    React.createElement("div", { className: 'cart-add-kit-nav' },
                        React.createElement("div", { className: 'add-grid' }, _this.addNewItemButtons())),
                    React.createElement(Dimmer.Dimmable, { as: 'div' },
                        React.createElement(Dimmer, { active: _this.state.cartLoading, inverted: true },
                            React.createElement(Loader, null)),
                        _this.state.cart && _this.showIncompatibilityMessage(_this.state.cart),
                        _this.state.cart
                            && React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Consumer, RelevantCatalogType.Cart, undefined, undefined), render: _this.getCatalogForCartItem(_this.state.cart) }),
                        _this.state.cart && _this.getOriginsCartItems(_this.state.cart).length === 0 &&
                            React.createElement(React.Fragment, null,
                                "Your cart is empty",
                                ORIGIN === "mi" && React.createElement("div", null,
                                    React.createElement(ShopLink, { to: AppPaths.LOCAL_NEW_KIT }, "Start a new order"),
                                    !_this.props.authenticated &&
                                        React.createElement(React.Fragment, null,
                                            ", or ",
                                            React.createElement(Link, { to: AppPaths.LOG_IN }, "log in"),
                                            " to view your saved cart.")),
                                ORIGIN === "hcr" && !_this.props.authenticated &&
                                    React.createElement("div", { style: { paddingTop: '5px', paddingBottom: '5px' } },
                                        React.createElement(Link, { to: AppPaths.LOG_IN }, "Log in"),
                                        " to view your saved cart.")),
                        _this.state.cart && _this.getOriginsCartItems(_this.state.cart).length > 0 && _this.showCartTotal(_this.state.cart))));
        };
        _this.getCatalogForCartItem = function (cart) { return function (catalog) {
            var items = cart.contents.filter(function (item) {
                return !item.kit.starterKit;
            }).map(function (item, idx) {
                return _this.showCartItems(item, idx, catalog);
            });
            items = uniqueStarterKitGroups(cart.contents).map(function (group, idx) {
                return React.createElement(StarterKitCartCard, { key: "starter-" + idx, kit: group.kit, kits: group.kits, deletable: true, onCartChange: _this.handleJsonCart, setParentLoadingState: _this.handleItemLoadingState });
            }).concat(items);
            return items;
        }; };
        _this.showCartTotal = function (cart) {
            var loadQuoteWrapper = function () {
                _this.getQuote(cart);
            };
            var disableProcession = !cart.contents.every(function (item) { return item instanceof ValidCartItem; });
            return React.createElement(React.Fragment, null,
                React.createElement("br", null),
                React.createElement("div", { className: 'cart-layout' },
                    React.createElement("div", { className: 'cart-total-summary' },
                        React.createElement("p", { className: 'cart-total' }, "Cart total (USD): $" + formatMonetaryDecimal(cart.subtotalCents)),
                        discountMessage(cart.discountCents, cart.listPriceSubtotalCents)),
                    React.createElement("div", { className: 'checkout' },
                        React.createElement(Modal, { closeIcon: true, content: React.createElement(PlaceOrderFromQuote, { quoteError: _this.state.quoteError, quoteNeedsLogin: _this.state.quoteNeedsLogin, quoteLoading: _this.state.quoteLoading, quote: _this.state.quoteResponse, routerProps: _this.props }), onOpen: loadQuoteWrapper, trigger: React.createElement(Button, { label: 'Review order', labelPosition: "left", icon: "dna", positive: true, disabled: disableProcession }), wide: "very" }))),
                ORIGIN === "hcr" && React.createElement(React.Fragment, null,
                    React.createElement("br", null),
                    "Interested in multiplexing capabilities or high-fidelity cell segmentation?",
                    React.createElement("br", null),
                    React.createElement("a", { style: { color: "#1E90FF" }, href: "mailto:info@molecularinstruments.com?subject=HCR™ Ancillaries and Multiplexing Capabilities" },
                        React.createElement("u", null, "Contact us")),
                    "."),
                React.createElement(UiConfigContext.Consumer, null, function (uiConfig) {
                    if (uiConfig.uiFeatures.has(FEATURE_CREATE_ORDER_FOR_USER)) {
                        return React.createElement(React.Fragment, null,
                            React.createElement(Divider, null),
                            React.createElement(Modal, { closeIcon: true, onClose: _this.loadCart, trigger: React.createElement(Button, { icon: 'magic', label: 'Create order for another user', labelPosition: 'left' }) },
                                React.createElement(Modal.Header, null, "Create an order from your cart for another user"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(CreateOrderForUser, null))));
                    }
                    return;
                }));
        };
        _this.loadCart = function () {
            _this.setState({
                cartLoading: true
            }, function () {
                var path = '/cart';
                getWithAuthn(path)
                    .then(function (resp) {
                    // TODO check for 200
                    return resp.json();
                })
                    .then(function (json) {
                    _this.handleJsonCart(json);
                    _this.setState({
                        cartLoading: false,
                        cartLoaded: true
                    });
                })
                    .catch(function (rej) {
                    console.error("Couldn't load cart: " + rej);
                });
            });
        };
        _this.getOriginsCartItems = function (cart) {
            return cart.contents.filter(function (ci) {
                if (ORIGIN === "hcr") {
                    return ci.kit instanceof AutomatedProKit;
                }
                else {
                    return ci.kit instanceof RnaFishKit || ci.kit instanceof SecondaryIfKit || ci.kit instanceof ManualProKit || ci.kit instanceof ManualGoldIfKit;
                }
            });
        };
        _this.getQuote = function (cart) {
            // as per https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce
            // start with begin_checkout
            gtag('event', 'begin_checkout', {
                value: cart.subtotalCents / 100.0,
                currency: 'USD',
                items: _this.getOriginsCartItems(cart)
                    .flatMap(function (i) {
                    if (i instanceof ValidCartItem) {
                        kitPriceToGoogleAnalyticsItems(i.pricedKit.price);
                    }
                })
            });
            var path = '/cart/quote';
            _this.setState({
                quoteError: false,
                quoteNeedsLogin: false,
                quoteLoading: true,
                quoteResponse: undefined
            }, function () {
                postWithAuthn(path)
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return resp.status;
                    }
                })
                    .then(function (q) {
                    if (typeof q === 'number') {
                        if (q === 401) {
                            _this.setState({
                                quoteNeedsLogin: true,
                                quoteLoading: false
                            });
                        }
                        else {
                            _this.setState({
                                quoteError: true,
                                quoteLoading: false
                            });
                        }
                        return;
                    }
                    var quote = deserializeQuote(q);
                    // record getting the quote as progress
                    gtag('event', 'checkout_progress', {
                        checkout_step: 1,
                        value: quote.subtotalCents / 100.0,
                        currency: 'USD',
                        items: quote.items.flatMap(function (i) { return kitPriceToGoogleAnalyticsItems(i.pricedKit.price); })
                    });
                    _this.setState({
                        quoteResponse: quote,
                        quoteLoading: false
                    });
                })
                    .catch(function (rej) {
                    console.error("Couldn't get quote: " + rej);
                });
            });
        };
        _this.handleJsonCart = function (c) {
            var cartKits = c.contents.map(function (j) {
                if (isValidCartItem(j)) {
                    return new ValidCartItem(j.id, j.quantity, KitDeserializer.deserializePricedKit(j.pricedKit));
                }
                else {
                    return new InvalidCartItem(j.id, j.quantity, new InvalidKit(KitDeserializer.deserialize(j.invalidKit), j.invalidKit.errors));
                }
            });
            var cart = new Cart(cartKits, c.subtotalCents, c.listPriceSubtotalCents, c.discountCents);
            var rnaCatalog;
            if (isConsumerCatalog(c.metaCatalog.rnaResponse)) {
                rnaCatalog = deserializeUserCatalog(c.metaCatalog.rnaResponse);
            }
            else {
                rnaCatalog = deserializeAdminCatalog(c.metaCatalog.rnaResponse);
            }
            var updatedCatalog = new MetaCatalog(rnaCatalog, deserializeSecondaryIfCatalog(c.metaCatalog.secondaryIfResponse));
            _this.setState({ cart: cart, updatedCatalog: updatedCatalog });
        };
        _this.handleItemLoadingState = function (loading) {
            _this.setState({ cartLoading: loading });
        };
        _this.automatedProKitCheck = function (kit) {
            return kit instanceof AutomatedProKit && (kit.probeSetComponent.length > 0 || kit.detectComponent !== undefined);
        };
        _this.proChromogenOnlyKitCheck = function (kit) {
            return kit instanceof AutomatedProKit && kit.chromogenComponent !== undefined &&
                kit.probeSetComponent.length === 0 && kit.detectComponent === undefined;
        };
        _this.addNewItemButtons = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("span", { className: 'add-kit-links-label' }, "Add kit:"),
                React.createElement("div", { className: 'add-kit-links' },
                    ORIGIN === "mi" &&
                        React.createElement(React.Fragment, null,
                            _this.addNewItemLink(AppPaths.LOCAL_NEW_KIT_RNA_FISH, "HCR™ Gold RNA-FISH"),
                            _this.addNewItemLink(AppPaths.LOCAL_NEW_KIT_ENCODER, "HCR™ Gold IF"),
                            _this.addNewItemLink(AppPaths.LOCAL_NEW_KIT_MANUAL_PRO, "HCR™ Pro RNA-ISH"),
                            _this.addNewItemLink(AppPaths.LOCAL_NEW_KIT_IHC2, "HCR™ Gold 2ºIF"),
                            _this.props.legacyUser && _this.addNewItemLink(AppPaths.LOCAL_NEW_LEGACY_KIT_RNA_FISH, "HCR™ RNA-FISH (v3.0)"),
                            _this.props.legacyUser && _this.addNewItemLink(AppPaths.LOCAL_NEW_LEGACY_KIT_IHC2, "HCR™ 2ºIF (v3.0)")),
                    ORIGIN === "hcr" &&
                        React.createElement(React.Fragment, null,
                            _this.addNewItemLink(AppPaths.LOCAL_NEW_KIT_RNA_CISH, "HCR™ Pro RNA-ISH Assay"),
                            _this.addNewItemLink(AppPaths.LOCAL_NEW_KIT_RNA_CISH_CHROMOGEN, "Matisse® Chromogen"))),
                ORIGIN === "mi" &&
                    React.createElement(React.Fragment, null,
                        React.createElement("span", { className: 'add-kit-links-label' }, "Upload:"),
                        React.createElement("div", { className: 'add-kit-links' },
                            React.createElement(BulkOrderModal, { onKitsAdded: _this.loadCart }))));
        };
        _this.addNewItemLink = function (to, label) {
            return React.createElement(Link, { className: 'add-kit-link', to: to }, label);
        };
        _this.state = {
            cartLoading: false,
            cart: undefined,
            quoteError: false,
            quoteNeedsLogin: false,
            quoteLoading: false,
            quoteResponse: undefined,
            cartLoaded: false
        };
        return _this;
    }
    CartPage.prototype.render = function () {
        if (this.state.cartLoaded) {
            return this.renderCartContents();
        }
        else {
            return React.createElement(Dimmer.Dimmable, { id: "non-header-portion" },
                React.createElement(Dimmer, { active: true, inverted: true },
                    React.createElement(Loader, null)));
        }
    };
    CartPage.prototype.componentDidMount = function () {
        this.loadCart();
    };
    return CartPage;
}(React.PureComponent));
export default CartPage;
// not clear why this is a class -- don't think we need to instanceof check it?
var Cart = /** @class */ (function () {
    function Cart(contents, subtotalCents, listPriceSubtotalCents, discountCents) {
        this.contents = contents;
        this.subtotalCents = subtotalCents;
        this.listPriceSubtotalCents = listPriceSubtotalCents;
        this.discountCents = discountCents;
    }
    return Cart;
}());
export { Cart };
var ValidCartItem = /** @class */ (function () {
    function ValidCartItem(id, quantity, pricedKit) {
        this.id = id;
        this.quantity = quantity;
        this.pricedKit = pricedKit;
        this.kit = pricedKit.kit;
    }
    return ValidCartItem;
}());
export { ValidCartItem };
var InvalidCartItem = /** @class */ (function () {
    function InvalidCartItem(id, quantity, invalidKit) {
        this.id = id;
        this.quantity = quantity;
        this.invalidKit = invalidKit;
        this.kit = invalidKit.kit;
    }
    return InvalidCartItem;
}());
export { InvalidCartItem };
var InvalidKit = /** @class */ (function () {
    function InvalidKit(kit, errors) {
        this.kit = kit;
        this.errors = errors;
    }
    return InvalidKit;
}());
export { InvalidKit };
var isValidCartItem = function (b) {
    return b._type === 'valid';
};
export var is4xx = function (status) {
    return status >= 400 && status < 500;
};
var PlaceOrderFromQuote = /** @class */ (function (_super) {
    __extends(PlaceOrderFromQuote, _super);
    function PlaceOrderFromQuote(props) {
        var _this = _super.call(this, props) || this;
        _this.showPlaceOrderButton = function (quote) {
            var placeOrder = function () {
                // clicking place order is another step
                gtag('event', 'checkout_progress', {
                    checkout_step: 2,
                    value: quote.subtotalCents / 100.0,
                    currency: 'USD',
                    items: quote.items.flatMap(function (i) { return kitPriceToGoogleAnalyticsItems(i.pricedKit.price); })
                });
                _this.setState({
                    placeOrderLoading: true,
                }, function () {
                    postJsonWithAuthn("/user/quote/id/" + encodeURIComponent(quote.id) + "/orderify", JSON.stringify({
                        nickname: _this.state.nickname,
                        sendCreditCardLink: _this.state.sendCreditCardLink
                    }))
                        .then(function (resp) {
                        if (resp.ok) {
                            resp.json()
                                .then(function (r) {
                                // order was placed
                                gtag('event', 'purchase', {
                                    transaction_id: r.orderId,
                                    value: quote.subtotalCents / 100.0,
                                    currency: 'USD',
                                    items: quote.items.flatMap(function (i) { return kitPriceToGoogleAnalyticsItems(i.pricedKit.price); })
                                });
                            }).catch(function (rej) {
                                console.error("Couldn't report txn to GA: " + rej);
                            });
                            // TODO show a thank you screen
                            _this.props.routerProps.history.push(AppPaths.ORDERS);
                        }
                        else {
                            _this.setState({
                                placeOrderLoading: false,
                                placeOrderError: true
                            });
                        }
                    })
                        .catch(function (rej) {
                        console.error("Couldn't place order: " + rej);
                    });
                });
            };
            return React.createElement(Button, { className: 'confirm-order', positive: true, label: ORIGIN === "mi" ? 'Place order' : "Submit Order", labelPosition: 'left', icon: 'handshake', onClick: placeOrder });
        };
        _this.onNicknameChange = function (event) {
            var value = event.currentTarget.value;
            _this.setState({ nickname: value });
        };
        _this.onSendCreditCardLinkChange = function () {
            _this.setState({ sendCreditCardLink: !_this.state.sendCreditCardLink });
        };
        _this.state = {
            placeOrderError: false,
            placeOrderLoading: false,
            nickname: '',
            sendCreditCardLink: false
        };
        return _this;
    }
    PlaceOrderFromQuote.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, { className: 'order-confirmation' },
                React.createElement(Dimmer, { active: this.props.quoteLoading || this.state.placeOrderLoading, inverted: true },
                    React.createElement(Loader, null)),
                this.props.quoteNeedsLogin &&
                    React.createElement(Message, { error: true },
                        "Please ",
                        React.createElement(Link, { to: AppPaths.LOG_IN }, "log in"),
                        " to start a purchase"),
                this.props.quoteError &&
                    React.createElement(Message, { error: true }, "Could not start purchase"),
                this.props.quote &&
                    React.createElement(React.Fragment, null,
                        React.createElement(QuoteDisplay, { quote: this.props.quote }),
                        React.createElement(Divider, null),
                        React.createElement(Form, null,
                            React.createElement(Form.Field, null,
                                React.createElement("label", null,
                                    "Nickname ",
                                    nicknameHelp),
                                React.createElement(TextArea, { onChange: this.onNicknameChange, placeholder: nicknamePlaceholder(), value: this.state.nickname }))),
                        this.state.placeOrderError
                            && React.createElement(Message, { error: true }, "Order could not be placed"),
                        React.createElement(Message, { className: 'quote-msg', info: true },
                            React.createElement(List, { bulleted: true },
                                React.createElement(List.Item, null, "You will receive an email quote that you can use to upload your Purchase Order"),
                                ORIGIN === "hcr" && React.createElement(List.Item, null, "We aim to ship within 5-7 business days upon receiving your valid PO for HCR\u2122 Pro RNA-ISH Kits"),
                                ORIGIN === "mi" && React.createElement(List.Item, null, "Upon receiving a valid purchase order, we aim to ship: within 1 business day for HCR\u2122 Amplifiers and HCR\u2122 Buffers, within 1-5 business days for HCR\u2122 HiFi Encoders and HCR\u2122 2\u00B0 Antibody Probes, and within 5-7 business days for HCR\u2122 HiFi Probes."),
                                React.createElement(List.Item, null, "To avoid delays during initial vendor setup, orders can be prepaid by credit card upon request"),
                                ORIGIN !== "mi" && React.createElement(List.Item, null,
                                    "All sales are subject to the ",
                                    React.createElement("a", { target: "_blank", href: "https://www.hcrimaging.com/legal/terms" }, "Terms")))),
                        React.createElement(Form.Field, null,
                            React.createElement(Checkbox, { label: 'Request Credit Card Invoice', onClick: this.onSendCreditCardLinkChange })),
                        this.showPlaceOrderButton(this.props.quote))));
    };
    return PlaceOrderFromQuote;
}(React.PureComponent));
export { PlaceOrderFromQuote };
export var deserializeQuote = function (q) {
    return {
        id: q.id,
        userName: q.userName,
        userEmail: q.userEmail,
        userPhone: q.userPhone,
        subtotalCents: q.subtotalCents,
        listPriceSubtotalCents: q.listPriceSubtotalCents,
        discountCents: q.discountCents,
        shippingAddress: q.shippingAddress,
        billingAddress: q.billingAddress,
        billingEmail: q.billingEmail,
        billingPhone: q.billingPhone,
        items: q.items.map(function (item) { return ({
            quantity: item.quantity,
            pricedKit: KitDeserializer.deserializePricedKit(item.pricedKit)
        }); }),
        shippingCostEstimate: q.shippingCostEstimate,
        handlingAndDryIce: q.handlingAndDryIce
    };
};
//# sourceMappingURL=CartPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/CartPage.js
// module id = 121
// module chunks = 0